import type { QuizSetMember, QuizGroupItem } from '@/types/quizSet'

/**
 * 세트 멤버를 flatten해서 quizId 순서 배열로 반환.
 * - kind === 'quiz'  → member.quiz.quizId
 * - kind === 'group' → member.group.items[].quiz.quizId (그룹 펼침)
 * 백엔드가 sequenceOrder 순으로 내려준 순서를 그대로 신뢰한다.
 */
export function flattenSetQuizIds(members: QuizSetMember[]): string[] {
  const ids: string[] = []
  for (const m of members) {
    if (m.kind === 'quiz' && m.quiz) {
      ids.push(String(m.quiz.quizId))
    } else if (m.kind === 'group' && m.group) {
      for (const it of m.group.items) {
        ids.push(String(it.quiz.quizId))
      }
    }
  }
  return ids
}

/** 그룹 아이템을 quizId 순서 배열로 반환 (이미 평면 구조). */
export function flattenGroupQuizIds(items: QuizGroupItem[]): string[] {
  return items.map((it) => String(it.quiz.quizId))
}
